// Recursos liberados por organização (campo `features` de GET /users/me/membership).
// O servidor é quem libera; o painel só esconde o que não está disponível.

export const RECURSO_CERTIFICADOS = 'certificates';
export const RECURSO_MFA_EMAIL = 'mfa_email';

/** `membership` pode vir sem `features` (servidor antigo) ou nulo (ainda carregando): nesses casos, não libera. */
export function temRecurso(membership: object | null | undefined, recurso: string): boolean {
  const features = (membership as { features?: unknown } | null | undefined)?.features;
  return Array.isArray(features) && features.includes(recurso);
}
